import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { showToast } from "./toastSlice";
import { toast } from "./toastTypes";

export function FeatureFlagOverrideToaster() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    let parsed: Record<string, boolean> | null = null;
    try {
      const raw = localStorage.getItem("featureFlagOverrides");
      if (!raw) return;
      const candidate = JSON.parse(raw);
      if (!candidate || typeof candidate !== "object" || Array.isArray(candidate)) return;
      parsed = candidate as Record<string, boolean>;
    } catch {
      return;
    }
    if (!parsed || Object.keys(parsed).length === 0) return;

    dispatch(showToast(toast(
      "featureFlagOverrides",
      { overrides: parsed },
      "feature-flag-overrides-active",
    )));
  }, [dispatch]);

  return null;
}
